'use strict';

var _toConsumableArray = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/toConsumableArray");

var _createForOfIteratorHelper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

var _assertThisInitialized = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createSuper");

var debug = require('debug');

var log = Object.assign(debug('libp2p:connection-manager'), {
  error: debug('libp2p:connection-manager:err')
});

var errcode = require('err-code');

var mergeOptions = require('merge-options');

var LatencyMonitor = require('./latency-monitor'); // @ts-ignore retimer does not have types


var retimer = require('retimer');

var _require = require('events'),
    EventEmitter = _require.EventEmitter;

var PeerId = require('peer-id');

var _require2 = require('../errors'),
    ERR_INVALID_PARAMETERS = _require2.codes.ERR_INVALID_PARAMETERS;

var defaultOptions = {
  maxConnections: Infinity,
  minConnections: 0,
  maxData: Infinity,
  maxSentData: Infinity,
  maxReceivedData: Infinity,
  maxEventLoopDelay: Infinity,
  pollInterval: 2000,
  autoDialInterval: 10000,
  movingAverageInterval: 60000,
  defaultPeerValue: 1
};
/**
 * @typedef {import('../')} Libp2p
 * @typedef {import('libp2p-interfaces/src/connection').Connection} Connection
 */

/**
 * @typedef {Object} ConnectionManagerOptions
 * @property {number} [maxConnections = Infinity] - The maximum number of connections allowed.
 * @property {number} [minConnections = 0] - The minimum number of connections to avoid pruning.
 * @property {number} [maxData = Infinity] - The max data (in and out), per average interval to allow.
 * @property {number} [maxSentData = Infinity] - The max outgoing data, per average interval to allow.
 * @property {number} [maxReceivedData = Infinity] - The max incoming data, per average interval to allow.
 * @property {number} [maxEventLoopDelay = Infinity] - The upper limit the event loop can take to run.
 * @property {number} [pollInterval = 2000] - How often, in milliseconds, metrics and latency should be checked.
 * @property {number} [movingAverageInterval = 60000] - How often, in milliseconds, to compute averages.
 * @property {number} [defaultPeerValue = 1] - The value of the peer.
 * @property {boolean} [autoDial = true] - Should preemptively guarantee connections are above the low watermark.
 * @property {number} [autoDialInterval = 10000] - How often, in milliseconds, it should preemptively guarantee connections are above the low watermark.
 */

/**
 *
 * @fires ConnectionManager#peer:connect Emitted when a new peer is connected.
 * @fires ConnectionManager#peer:disconnect Emitted when a peer is disconnected.
 */

var ConnectionManager = /*#__PURE__*/function (_EventEmitter) {
  _inherits(ConnectionManager, _EventEmitter);

  var _super = _createSuper(ConnectionManager);

  /**
   * Responsible for managing known connections.
   *
   * @class
   * @param {Libp2p} libp2p
   * @param {ConnectionManagerOptions} options
   */
  function ConnectionManager(libp2p) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, ConnectionManager);

    _this = _super.call(this);
    _this._libp2p = libp2p;
    _this._peerId = libp2p.peerId.toB58String();
    _this._options = mergeOptions.call({
      ignoreUndefined: true
    }, defaultOptions, options);

    if (_this._options.maxConnections < _this._options.minConnections) {
      throw errcode(new Error('Connection Manager maxConnections must be greater than minConnections'), ERR_INVALID_PARAMETERS);
    }

    log('options: %j', _this._options);
    /**
     * Map of peer identifiers to their peer value for pruning connections.
     *
     * @type {Map<string, number>}
     */

    _this._peerValues = new Map();
    /**
     * Map of connections per peer
     *
     * @type {Map<string, Connection[]>}
     */

    _this.connections = new Map();
    _this._started = false;
    _this._timer = null;
    _this._autoDialTimeout = null;
    _this._checkMetrics = _this._checkMetrics.bind(_assertThisInitialized(_this));
    _this._autoDial = _this._autoDial.bind(_assertThisInitialized(_this));
    _this._latencyMonitor = new LatencyMonitor({
      latencyCheckIntervalMs: _this._options.pollInterval,
      dataEmitIntervalMs: _this._options.pollInterval
    });
    return _this;
  }
  /**
   * Get current number of open connections.
   */


  _createClass(ConnectionManager, [{
    key: "size",
    get: function get() {
      return Array.from(this.connections.values()).reduce(function (accumulator, value) {
        return accumulator + value.length;
      }, 0);
    }
    /**
     * Starts the Connection Manager. If Metrics are not enabled on libp2p
     * only event loop and connection limits will be monitored.
     */

  }, {
    key: "start",
    value: function start() {
      if (this._libp2p.metrics) {
        this._timer = this._timer || retimer(this._checkMetrics, this._options.pollInterval);
      } // latency monitor


      this._latencyMonitor.start();

      this._onLatencyMeasure = this._onLatencyMeasure.bind(this);

      this._latencyMonitor.on('data', this._onLatencyMeasure);

      this._started = true;
      log('started');
      this._options.autoDial && this._autoDial();
    }
    /**
     * Stops the Connection Manager
     *
     * @async
     */

  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this._autoDialTimeout && this._autoDialTimeout.clear();
                this._timer && this._timer.clear();

                this._latencyMonitor.removeListener('data', this._onLatencyMeasure);

                this._latencyMonitor.stop();

                this._started = false;
                _context.next = 7;
                return this._close();

              case 7:
                log('stopped');

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function stop() {
        return _stop.apply(this, arguments);
      }

      return stop;
    }()
    /**
     * Cleans up the connections
     *
     * @async
     */

  }, {
    key: "_close",
    value: function () {
      var _close2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var tasks, _iterator, _step, connectionList, _iterator2, _step2, connection;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // Close all connections we're tracking
                tasks = [];
                _iterator = _createForOfIteratorHelper(this.connections.values());

                try {
                  for (_iterator.s(); !(_step = _iterator.n()).done;) {
                    connectionList = _step.value;
                    _iterator2 = _createForOfIteratorHelper(connectionList);

                    try {
                      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                        connection = _step2.value;
                        tasks.push(connection.close());
                      }
                    } catch (err) {
                      _iterator2.e(err);
                    } finally {
                      _iterator2.f();
                    }
                  }
                } catch (err) {
                  _iterator.e(err);
                } finally {
                  _iterator.f();
                }

                _context2.next = 5;
                return Promise.all(tasks);

              case 5:
                this.connections.clear();

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _close() {
        return _close2.apply(this, arguments);
      }

      return _close;
    }()
    /**
     * Sets the value of the given peer. Peers with lower values
     * will be disconnected first.
     *
     * @param {PeerId} peerId
     * @param {number} value - A number between 0 and 1
     * @returns {void}
     */

  }, {
    key: "setPeerValue",
    value: function setPeerValue(peerId, value) {
      if (value < 0 || value > 1) {
        throw new Error('value should be a number between 0 and 1');
      }

      this._peerValues.set(peerId.toB58String(), value);
    }
    /**
     * Checks the libp2p metrics to determine if any values have exceeded
     * the configured maximums.
     *
     * @private
     */

  }, {
    key: "_checkMetrics",
    value: function _checkMetrics() {
      if (this._libp2p.metrics) {
        var movingAverages = this._libp2p.metrics.global.movingAverages; // @ts-ignore moving averages object types

        var received = movingAverages.dataReceived[this._options.movingAverageInterval].movingAverage();

        this._checkMaxLimit('maxReceivedData', received); // @ts-ignore moving averages object types


        var sent = movingAverages.dataSent[this._options.movingAverageInterval].movingAverage();

        this._checkMaxLimit('maxSentData', sent);

        var total = received + sent;

        this._checkMaxLimit('maxData', total);

        log('metrics update', total);
        this._timer = retimer(this._checkMetrics, this._options.pollInterval);
      }
    }
    /**
     * Tracks the incoming connection and check the connection limit
     *
     * @param {Connection} connection
     * @returns {void}
     */

  }, {
    key: "onConnect",
    value: function onConnect(connection) {
      var peerId = connection.remotePeer;
      var peerIdStr = peerId.toB58String();
      var storedConn = this.connections.get(peerIdStr);
      this.emit('peer:connect', connection);

      if (storedConn) {
        storedConn.push(connection);
      } else {
        this.connections.set(peerIdStr, [connection]);
      }

      this._libp2p.peerStore.keyBook.set(peerId, peerId.pubKey);

      if (!this._peerValues.has(peerIdStr)) {
        this._peerValues.set(peerIdStr, this._options.defaultPeerValue);
      }

      this._checkMaxLimit('maxConnections', this.size);
    }
    /**
     * Removes the connection from tracking
     *
     * @param {Connection} connection
     * @returns {void}
     */

  }, {
    key: "onDisconnect",
    value: function onDisconnect(connection) {
      var peerId = connection.remotePeer.toB58String();
      var storedConn = this.connections.get(peerId);

      if (storedConn && storedConn.length > 1) {
        storedConn = storedConn.filter(function (conn) {
          return conn.id !== connection.id;
        });
        this.connections.set(peerId, storedConn);
      } else if (storedConn) {
        this.connections.delete(peerId);

        this._peerValues.delete(connection.remotePeer.toB58String());

        this.emit('peer:disconnect', connection);
      }
    }
    /**
     * Get a connection with a peer.
     *
     * @param {PeerId} peerId
     * @returns {Connection|null}
     */

  }, {
    key: "get",
    value: function get(peerId) {
      var connections = this.getAll(peerId);

      if (connections.length) {
        return connections[0];
      }

      return null;
    }
    /**
     * Get all open connections with a peer.
     *
     * @param {PeerId} peerId
     * @returns {Connection[]}
     */

  }, {
    key: "getAll",
    value: function getAll(peerId) {
      if (!PeerId.isPeerId(peerId)) {
        throw errcode(new Error('peerId must be an instance of peer-id'), ERR_INVALID_PARAMETERS);
      }

      var id = peerId.toB58String();
      var connections = this.connections.get(id); // Return all open connections

      if (connections) {
        return connections.filter(function (connection) {
          return connection.stat.status === 'open';
        });
      }

      return [];
    }
    /**
     * If the event loop is slow, maybe close a connection
     *
     * @private
     * @param {*} summary - The LatencyMonitor summary
     */

  }, {
    key: "_onLatencyMeasure",
    value: function _onLatencyMeasure(summary) {
      this._checkMaxLimit('maxEventLoopDelay', summary.avgMs);
    }
    /**
     * If the `value` of `name` has exceeded its limit, maybe close a connection
     *
     * @private
     * @param {string} name - The name of the field to check limits for
     * @param {number} value - The current value of the field
     */

  }, {
    key: "_checkMaxLimit",
    value: function _checkMaxLimit(name, value) {
      var limit = this._options[name];
      log('checking limit of %s. current value: %d of %d', name, value, limit);

      if (value > limit) {
        log('%s: limit exceeded: %s, %d', this._peerId, name, value);

        this._maybeDisconnectOne();
      }
    }
    /**
     * Proactively tries to connect to known peers stored in the PeerStore.
     * It will keep the number of connections below the upper limit and sort
     * the peers to connect based on wether we know their keys and protocols.
     *
     * @async
     * @private
     */

  }, {
    key: "_autoDial",
    value: function () {
      var _autoDial2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var minConnections, peers, i;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                minConnections = this._options.minConnections; // Already has enough connections

                if (!(this.size >= minConnections)) {
                  _context3.next = 4;
                  break;
                }

                this._autoDialTimeout = retimer(this._autoDial, this._options.autoDialInterval);
                return _context3.abrupt("return");

              case 4:
                // Sort peers on wether we know protocols of public keys for them
                peers = Array.from(this._libp2p.peerStore.peers.values()).sort(function (a, b) {
                  if (b.protocols && b.protocols.length && (!a.protocols || !a.protocols.length)) {
                    return 1;
                  } else if (b.id.pubKey && !a.id.pubKey) {
                    return 1;
                  }

                  return -1;
                });
                i = 0;

              case 6:
                if (!(i < peers.length && this.size < minConnections)) {
                  _context3.next = 22;
                  break;
                }

                if (this.get(peers[i].id)) {
                  _context3.next = 19;
                  break;
                }

                log('connecting to a peerStore stored peer %s', peers[i].id.toB58String());
                _context3.prev = 9;
                _context3.next = 12;
                return this._libp2p.dialer.connectToPeer(peers[i].id);

              case 12:
                if (this._started) {
                  _context3.next = 14;
                  break;
                }

                return _context3.abrupt("return");

              case 14:
                _context3.next = 19;
                break;

              case 16:
                _context3.prev = 16;
                _context3.t0 = _context3["catch"](9);
                log.error('could not connect to peerStore stored peer', _context3.t0);

              case 19:
                i++;
                _context3.next = 6;
                break;

              case 22:
                this._autoDialTimeout = retimer(this._autoDial, this._options.autoDialInterval);

              case 23:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[9, 16]]);
      }));

      function _autoDial() {
        return _autoDial2.apply(this, arguments);
      }

      return _autoDial;
    }()
    /**
     * If we have more connections than our maximum, close a connection
     * to the lowest valued peer.
     *
     * @private
     */

  }, {
    key: "_maybeDisconnectOne",
    value: function _maybeDisconnectOne() {
      if (this._options.minConnections < this.connections.size) {
        var peerValues = Array.from(new Map(_toConsumableArray(this._peerValues.entries()).sort(function (a, b) {
          return a[1] - b[1];
        })));
        log('%s: sorted peer values: %j', this._peerId, peerValues);
        var disconnectPeer = peerValues[0];

        if (disconnectPeer) {
          var peerId = disconnectPeer[0];
          log('%s: lowest value peer is %s', this._peerId, peerId);
          log('%s: closing a connection to %j', this._peerId, peerId);

          var _iterator3 = _createForOfIteratorHelper(this.connections.values()),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var connections = _step3.value;

              if (connections[0].remotePeer.toB58String() === peerId) {
                connections[0].close();
                break;
              }
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }
    }
  }]);

  return ConnectionManager;
}(EventEmitter);

module.exports = ConnectionManager;